import { render, staticRenderFns } from "./CollectionContentRowItem.vue?vue&type=template&id=494e37b1&scoped=true&"
import script from "./CollectionContentRowItem.vue?vue&type=script&lang=js&"
export * from "./CollectionContentRowItem.vue?vue&type=script&lang=js&"
import style0 from "./CollectionContentRowItem.vue?vue&type=style&index=0&id=494e37b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494e37b1",
  null
  
)

export default component.exports